import React, { Component } from "react";
import OwlCarousel from "react-owl-carousel2";
import "react-owl-carousel2/src/owl.carousel.css";
import "react-owl-carousel2/src/owl.theme.default.css";
// import view_all_arrow_mm from "../../assets/images/view_all_arrow_mm.png";

import dummyImage from "../../assets/images/banner_placeholder.jpg";

export default class LayoutCastandCrew extends Component {
  state = {
    castData: [],
  };
  componentDidMount() {
    if (this.props.info && this.props.info.relatedCast) {
      this.setState({
        castData: this.props.info.relatedCast.values,
      });
    }
  }
  getCastData = () => {
    return this.state.castData.map((item, i) => {
      // var src='';
      var imageArray = [];
      if (Object.keys(item.images).length > 0) {
        if (
          item.images.values.filter((value, i) => {
            return (value.profile = "hdpi");
          }).length > 0
        ) {
          imageArray = item.images.values.filter((value, i) => {
            return (value.profile = "hdpi");
          });
        } else if (
          item.images.values.filter((value, i) => {
            return (value.profile = "mdpi");
          }).length > 0
        ) {
          imageArray = item.images.values.filter((value, i) => {
            return (value.profile = "mdpi");
          });
        } else if (
          item.images.values.filter((value, i) => {
            return (value.profile = "ldpi");
          }).length > 0
        ) {
          imageArray = item.images.values.filter((value, i) => {
            return (value.profile = "ldpi");
          });
        } else if (
          item.images.values.filter((value, i) => {
            return (value.profile = "xhdpi");
          }).length > 0
        ) {
          imageArray = item.images.values.filter((value, i) => {
            return (value.profile = "xhdpi");
          });
        } else if (
          item.images.values.filter((value, i) => {
            return (value.profile = "xxhdpi");
          }).length > 0
        ) {
          imageArray = item.images.values.filter((value, i) => {
            return (value.profile = "xxhdpi");
          });
        }
      }
      return (
        <div key={i}>
          <div className="profile_radio_section">
            <img
              src={
                imageArray.length > 0 && Object.keys(item.images).length > 0
                  ? imageArray[0].link
                  : dummyImage
              }
              alt={`castandcrew${item.name}`}
              className="profile_radio_circle"
            />
            <h4>{item.name}</h4>
            <h5>{item.types.join()}</h5>
          </div>
        </div>
      );
    });
  };
  render() {
    let perpage = 0;

    if (
      this.props.layoutType === "horizontalListBigItem" ||
      this.props.layoutType === "previewCarousel" ||
      this.props.layoutType === "roundedArtistCarousel"
    ) {
      perpage = 10;
    } else if (this.props.layoutType === "nestedCarousel") {
      perpage = 8;
    } else {
      perpage = 7;
    }

    const options = {
      items: perpage,

      responsive: {
        320: {
          items: perpage === 10 ? 2 : perpage === 8 ? 4 : 2,
          nav: true,
        },
        360: {
          items: perpage === 10 ? 3 : perpage === 8 ? 4 : 3,
          nav: true,
        },
        481: {
          items: perpage === 10 ? 3 : perpage === 8 ? 4 : 3,
          nav: false,
        },
        768: {
          items: perpage === 10 ? 4 : perpage === 8 ? 5 : 4,
          nav: false,
        },
        1200: {
          items: perpage === 10 ? 6 : perpage === 8 ? 5 : 5,
          nav: true,
        },
        1300: {
          items: perpage === 10 ? 7 : perpage === 8 ? 6 : 7,
          nav: true,
        },
        1400: {
          items: perpage === 10 ? 8 : perpage === 8 ? 6 : 8,
          nav: true,
        },
        1500: {
          items: perpage === 10 ? 8 : perpage === 8 ? 6 : 8,
          nav: true,
        },
        1600: {
          items: perpage === 10 ? 9 : perpage === 8 ? 7 : 8,
          nav: true,
        },
        1700: {
          items: perpage === 10 ? 10 : perpage === 8 ? 7 : 8,
          nav: true,
        },
      },
      nav: true,
      navText: [
        "<div class='carousel-nav-btn carousel-prev-slide'></div>",
        "<div class='carousel-nav-btn carousel-next-slide'></div>",
      ],
      rewind: false,
      margin: 10,
      dots: false,
      autoplay: false,
      slideBy: 10,
      loop: false,
      touchDrag: true,
      mouseDrag: true,
    };

    const events = {
      onDragged: function (event) {},
      onChanged: function (event) {},
    };
    return (
      <div className="profile_radio_carousel">
        {this.state.castData.length > 0 && (
          <div className="carousel_body">
            <div className="home_carosel_title">
              <h1>Cast & Crew</h1>
             
            </div>
            {this.state.castData.length > 0 && (
              <OwlCarousel ref="car" options={options} events={events}>
                {this.getCastData()}
              </OwlCarousel>
            )}
          </div>
        )}
      </div>
    );
  }
}
